import { Component, OnInit } from '@angular/core';
import { PageBaseComponent } from './page-base.component';
import { Router } from '@angular/router';
import { AuthService, DatasourceService } from '@app/core/services';
import { ZonedDate } from "@progress/kendo-date-math";
import { IntlService } from '@progress/kendo-angular-intl';
import { environment } from '@environments/environment';


@Component({
  selector: 'history',
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-list.css'],
  styles: [`
    .k-listview {
      margin-bottom: 0px;
    }
  `],
  template: `

    <div class="wrapper-route">

      <div class="row" style="padding-bottom: 8px; padding-left: 12px;">        
        <div class="col-xs-12 col-sm-12 example-col">
          <div class="component-container">
            <kendo-label text="Fecha: ">
              <kendo-datepicker [value]="value" [format]="'dd-MMM-yyyy'" placeholder="Choose a date ..." (valueChange)="onDateChange($event)"></kendo-datepicker>
            </kendo-label>
          </div>
        </div>
      </div>

      <diario-info [data]="data" [loading]="loading" ></diario-info>

      <div class="k-block" *ngIf="loading">
        <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
      </div>

      <div class="wrapper" *ngIf="!loading">

        <kendo-tabstrip  style="padding-top: 20px; padding-bottom: 80px;">
          <kendo-tabstrip-tab title="Liberaciones ({{total_vehicles}})" [selected]="true">
            <ng-template kendoTabContent>

              <subtotal-info [data]="subtotal_vehicles"></subtotal-info>

              <kendo-listview [kendoListViewBinding]="data_vehicles" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="!loading && data_vehicles.length">
                <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
                  <vehicle-history-card class="card" [vehicle]="dataItem" [returnUrl]="'history'" [borderTop]="!isFirst"></vehicle-history-card>
                </ng-template>
              </kendo-listview>

            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="Servicios ({{total_services}})">
            <ng-template kendoTabContent>
              
              <subtotal-info [data]="subtotal_services"></subtotal-info>

              <kendo-listview [kendoListViewBinding]="data_services" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="!loading && data_services.length">
                <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
                  <service-card class="card" [service]="dataItem" [returnUrl]="'history'" [borderTop]="!isFirst"></service-card>
                </ng-template>
              </kendo-listview>

            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="Créditos ({{total_credits}})">
            <ng-template kendoTabContent>
              
              <subtotal-info [data]="subtotal_credits"></subtotal-info>

              <div *ngIf="data_credits.length && data_receipts.length" style="width: 100%; text-align: center">
                <kendo-switch [checked]="checked" onLabel="Recibos" offLabel="Conceptos" style="width: 105px;" (valueChange)="onChange($event)"></kendo-switch>
              </div>

              <kendo-listview [kendoListViewBinding]="data_credits" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="!checked && !loading && data_credits.length">
                <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
                  <credit-payment-card class="card" [credit]="dataItem" [returnUrl]="'history'" [borderTop]="!isFirst" ></credit-payment-card>
                </ng-template>
              </kendo-listview>

              <kendo-listview [kendoListViewBinding]="data_receipts" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="checked && !loading && data_receipts.length">
                <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
                  <receipt-card class="card" [receipt]="dataItem" [returnUrl]="'history'" [borderTop]="!isFirst" ></receipt-card>
                </ng-template>
              </kendo-listview>

            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="Gastos ({{total_expenses}})">
            <ng-template kendoTabContent>
              
              <subtotal-info [data]="subtotal_expenses"></subtotal-info>

              <kendo-listview [kendoListViewBinding]="data_expenses" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="!loading && data_expenses.length">
                <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
                  <expense-card class="card" [expense]="dataItem" [returnUrl]="'history'" [borderTop]="!isFirst"></expense-card>
                </ng-template>
              </kendo-listview>

            </ng-template>
          </kendo-tabstrip-tab>
        </kendo-tabstrip>
      </div>

    </div>

  `
})
export class HistoryComponent extends PageBaseComponent implements OnInit {

  public data: any[];

  public data_vehicles: any[];
  public data_services: any[];
  public data_credits: any[];
  public data_receipts: any[];
  public data_expenses: any[];

  public subtotal_vehicles: any;
  public subtotal_services: any
  public subtotal_credits: any;
  public subtotal_expenses: any;

  public total_vehicles: number;
  public total_services: number;
  public total_credits: number;
  public total_expenses: number;

  public value: Date = new Date();

  public checked: boolean = false;


  constructor(public authService: AuthService, protected router: Router, protected service : DatasourceService, protected intl: IntlService) { 

    super(authService, router)

    let date: string = localStorage.getItem(environment.appName + '-history-date');
    let tzDate = ZonedDate.fromUTCDate((date != null) ? new Date(date) : new Date(), environment.timezone);
    this.value = new Date(tzDate.toUTCString().replace('Dev', 'Dec'))
    // console.log(date, this.value);

  }

  ngOnInit() { 
    
    this.update(this.intl.formatDate(this.value, "yyyy-MM-dd"));
    
  }

  public onDateChange(value: any): void {

    let d = this.intl.formatDate(value, "yyyy-MM-dd");
    localStorage.setItem(environment.appName + '-history-date', d); 
    this.update(d);    

  }

  public update(date: String) {

    this.loading = true;

    this.service.post('diario', {date: date})
      .subscribe(
        (result: any) => {
          console.log(result);

          this.data = result;

          this.data_vehicles = result.salidas.all.detail;
          this.total_vehicles = result.salidas.all.detail.length;

          this.subtotal_vehicles = {
            efectivo: result.salidas.efectivo.sum,
            other: result.salidas.other.sum,
            total: result.salidas.all.sum,
          };

          this.data_services = result.servicios.all.detail;
          this.total_services = result.servicios.all.detail.length;

          this.subtotal_services = {
            efectivo: result.servicios.efectivo.sum,
            other: result.servicios.other.sum,
            total: result.servicios.all.sum,
          };

          this.data_credits = result.creditos.all.detail;
          this.total_credits = result.creditos.all.detail.length;

          this.subtotal_credits = {
            efectivo: result.creditos.efectivo.sum,
            other: result.creditos.other.sum,
            total: result.creditos.all.sum,
          };

          this.data_receipts = result.recibos.all.detail;

          this.data_expenses = result.gastos.all.detail;
          this.total_expenses = result.gastos.all.detail.length;

          this.subtotal_expenses = {
            efectivo: result.gastos.efectivo.sum,
            other: result.gastos.other.sum,
            total: result.gastos.all.sum,
          };

          this.loading = false;
        },
        (error: any) => {
            console.log(error)
            this.loading = false;
        });

  }

  public onChange(value: boolean): void {
    this.checked = value;
    // console.log(`valueChange ${value}`);
  }

}